// src/components/icons/PdfAcrobatIcon.jsx  (yolunu senin yapına göre düzelt)
import React from "react";
import {pdfIconWebp} from "../../../../imagepath" // <- yolu kendi dizinine göre ayarla

export default function PdfAcrobatIcon({ size = 18, className = "", alt = "PDF" }) {
  return (
    <img
      src={pdfIconWebp}
      width={size}
      height={size}
      alt={alt}
      className={className}
      loading="lazy"
      draggable={false}
      style={{ display: "inline-block", verticalAlign: "middle" }}
    />
  );
}
